<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Select Projects</p>
    </header>
    <section class="modal-card-body">
      <div class="tabs is-fullwidth is-toggle is-marginless mb-3">
        <ul>
          <li v-for="tab in tabs" :key="tab"
            @click="activeTab = tab"
            :class="{ 'is-active': activeTab === tab }">
            <a>{{ tab }}</a>
          </li>
        </ul>
      </div>
      <div>
        <h3 v-if="projects.length > 0" class="has-text-white is-size-3 has-background-grey py-3 pl-2">
          <span class="mr-2"><input type="checkbox" @change="toggleAll" /></span>
          <span class="has-text-weight-bold">Projects</span>
        </h3>
        <h3 v-else-if="!store.state.isLoading" class="is-size-3 has-text-white p-4 has-background-grey">
          {{ activeTab === 'Subscribe' ? 'No projects available to subscribe' : 'No projects are subscribed' }}
        </h3>
        <div class="column scriptions" v-for="project in projects" :key="project._id">
          <div class="columns line-height">
            <div class="column is-narrow pl-2">
              <input type="checkbox" :value="project._id" v-model="selectedProjects" />
            </div>
            <div class="column has-text-black-bis is-size-3">
              {{ project.name }}
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot is-justify-content-end">
      <button class="button is-outlined" type="button" @click="$emit('close')">Close</button>
      <button class="button has-background-dark " type="button"
        :disabled="selectedProjects.length === 0"
        @click="subscribe()">
        {{ activeTab === 'Subscribe' ? 'Subscribe' : 'UnSubscribe' }}
      </button>
    </footer>
  </div>
</template>

<script>
import { reactive, toRefs, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import Subscriptions from '@/models/Subscriptions';
import { DialogProgrammatic } from '@/components/Dialog';

export default ({
  name: 'ManageSubscription',
  emits: ['close'],
  setup(props, { emit }) {
    const toast = useToast();
    const store = useStore();
    const tabs = ['Subscribe', 'UnSubscribe'];
    const data = reactive({
      activeTab: 'Subscribe',
      projects: [],
      selectedProjects: [],
    });

    const loadProjects = async () => {
      store.commit('setLoading', true);
      try {
        if (data.activeTab === 'Subscribe') {
          data.projects = await Subscriptions.getUnSubscribedProjects({ limit: 100, page: 1 });
        } else {
          data.projects = await Subscriptions.getSubscribedProjects({ limit: 100, page: 1 });
        }
      } catch {
        toast.error('Error loading projects');
      } finally {
        store.commit('setLoading', false);
        data.selectedProjects = [];
      }
    };

    const toggleAll = (e) => {
      data.selectedProjects = e.target.checked
        ? data.projects.map((p) => p._id)
        : [];
    };

    const subscribe = () => {
      const message = data.activeTab === 'Subscribe'
        ? 'You will be notified for any of your order updates across project'
        : 'All order notifications for the selected projects will be stopped. Continue?';

      DialogProgrammatic.confirm({
        title: 'Warning',
        message,
        type: 'warning',
        okButton: 'Yes',
        cancelButton: 'Cancel',
        onConfirm: async () => {
          store.commit('setLoading', true);
          try {
            if (data.activeTab === 'Subscribe') {
              await Subscriptions.subscribeToProjects({ projects: data.selectedProjects });
              toast.success('Project subscribed');
            } else {
              await Subscriptions.unsubscribe({ projects: data.selectedProjects });
              toast.success('Project unsubscribed');
            }
            data.activeTab = data.activeTab === 'Subscribe' ? 'UnSubscribe' : 'Subscribe';
            await loadProjects();
          } catch {
            toast.error('Error: please contact ManufactOn support');
            store.commit('setLoading', false);
          }
        },
      });
    };

    watch(() => data.activeTab, loadProjects);
    onMounted(loadProjects);

    return {
      ...toRefs(data),
      store,
      tabs,
      toggleAll,
      subscribe,
    };
  },
});
</script>
